import mainLogo from '../Assets/img/logo.png'
import homeBanner from '../Assets/img/banner-img.svg'
import call from '../Assets/img/call.svg'
import location from '../Assets/img/pin.svg'
import email from '../Assets/img/email.svg'
import paper from '../Assets/img/paper-plane.svg'
import ftrlogo from '../Assets/img/logo-2.png'
import facebook from '../Assets/img/Facebook.svg'
import insta from '../Assets/img/Instagram.svg'
import twitter from '../Assets/img/Twitter.svg'
import linked from '../Assets/img/linked-in.svg'
import product from '../Assets/img/Group-923.svg'
import expyrs from '../Assets/img/Group-927.svg'
import ux from '../Assets/img/Group-925.svg'
import strongvalue from '../Assets/img/Group-929.svg'
import quality from '../Assets/img/Group-931.svg'
import support from '../Assets/img/Group-933.svg'
import node from '../Assets/img/nodejs.svg'
import metore from '../Assets/img/meteor.svg'
import react from '../Assets/img/react.svg'
import angular from '../Assets/img/Angular.svg'
import native from '../Assets/img/react.svg'
import aws from '../Assets/img/aws.svg'
import mongo from '../Assets/img/mongo.svg'
import android from '../Assets/img/android.svg'
import apple from '../Assets/img/apple.svg'
import graph from '../Assets/img/graph.svg'
import graphql from '../Assets/img/apollo-graphql-compact.svg'
import laravel from '../Assets/img/laravel.svg'
import mysql from '../Assets/img/mysql.svg'
import profile from '../Assets/img/c1.jpeg'
import quote from '../Assets/img/quote.svg'
import dotted from '../Assets/img/bg-dotted.svg'
import virus from '../Assets/img/coronavirus.svg'
import customer from '../Assets/img/customer.svg'
import startup from '../Assets/img/start-up.svg'
import rightarrow from '../Assets/img/long-arrow.svg'
import trust1 from '../Assets/img/Group-1092.png'
import trust2 from '../Assets/img/Group-1093.png'
import trust3 from '../Assets/img/Group-1094.png'
import trust4 from '../Assets/img/Group-1095.png'
import trust5 from '../Assets/img/Group-1096.png'
import playbtn from '../Assets/img/icons-play.png'
import banner2 from '../Assets/img/reformer-img.png'
import object from '../Assets/img/OBJECTS.svg'
import badge from '../Assets/img/badge.png'
import satisfaction from '../Assets/img/satisfaction.png'
import technology from '../Assets/img/technology.png'
import team from '../Assets/img/team.svg'
import response from '../Assets/img/social-responsibility.png'
import ceo from '../Assets/img/CEO.png'
import cto from '../Assets/img/CTO.png'
import iconquote from '../Assets/img/icons-quote.png'
import servicebanner from '../Assets/img/services-banner.svg'
import s1 from '../Assets/img/s1.svg'
import s4 from '../Assets/img/s4.svg'
import Outline from '../Assets/img/Outline.svg'
import smartphone from '../Assets/img/smartphone.svg'
import poc from '../Assets/img/poc.svg'
import productlife from '../Assets/img/product-life.svg'
import sellproduct from '../Assets/img/sell-product.svg'
import search from '../Assets/img/search.svg'
import piechart from '../Assets/img/pie-chart.svg'
import employee from '../Assets/img/employee.svg'
import Ecommercesolution from '../Assets/img/Ecommerce-solution.svg'
import getstarted from '../Assets/img/get-started.png'
import rating from '../Assets/img/rating.png'
import paintbrush from '../Assets/img/paint-brush.png'
import rocket from '../Assets/img/rocket.png'
import timemanagement from '../Assets/img/time-management.png'
import settings from '../Assets/img/settings.svg'
import usergroup from '../Assets/img/user-group.svg'
import tyreexpert from '../Assets/img/tyre-expert.svg'
import headphones from '../Assets/img/headphones.svg'
import lowprices from '../Assets/img/low-prices.svg'
import tech from '../Assets/img/tech.svg'
import workbanner from '../Assets/img/group-4655.svg'
import careerbanner from '../Assets/img/career-banner.svg'
import careersettings from '../Assets/img/career-settings.svg'
import goal from '../Assets/img/goal.svg'
import implementation from '../Assets/img/implementation.svg'
import send from '../Assets/img/send.svg'
import blogbanner from '../Assets/img/blog-image.svg'
import vaidehi from '../Assets/img/Vaidehi.png'
import axita from '../Assets/img/Akshita.png'
import jemin from '../Assets/img/Jemin.png'
import ronak from '../Assets/img/Ronak.png'
import dipak from '../Assets/img/Deepak.png'
import amit from '../Assets/img/Amit.png'
import raj from '../Assets/img/Raj.png'
import nikul from '../Assets/img/Nikul.png'
import vaman from '../Assets/img/Vaman.png'
import jemis from '../Assets/img/Jemish.png'
import ankit from '../Assets/img/Ankit.png'
import yash from '../Assets/img/Yash.png'
import dhruvil from '../Assets/img/Dhruvil.png'
import hemant from '../Assets/img/Hemant.png'
import hr from '../Assets/img/HR.png'
import hiral from '../Assets/img/Hiral.png'
import prathna from '../Assets/img/Prathna.png'
import dhruvi from '../Assets/img/Dhruvi.png'
import dhruti from '../Assets/img/Dhruti.png'
import viral from '../Assets/img/Viral.png'
import shruti from '../Assets/img/Shruti.png'
import jaya from '../Assets/img/Jaya.png'
import cancle from '../Assets/img/cancle.png'
import eventbanner from '../Assets/img/event-banner.svg'
import longarrow from '../Assets/img/long-arrow-pointing-up.png'
import culturebanner from '../Assets/img/culturebanner.png'
import reformerimg from '../Assets/img/reformer-img.png'
import championbanner from '../Assets/img/champion-banner.svg'
import contactbanner from '../Assets/img/contact-banner.svg'
import loactions from '../Assets/img/Location.svg'
import perksOne from '../Assets/img/perksOne.png'
import perksTwo from '../Assets/img/perksTwo.png'
import perksThree from '../Assets/img/perksThree.png'
import perksFour from '../Assets/img/perksFour.png'



const WebDevelopment = () => <svg xmlns="http://www.w3.org/2000/svg" width="37.171"
    height="37.171" viewBox="0 0 37.171 37.171">
    <g transform="translate(0.2 0.2)">
        <path className="a"
            d="M33.409,7.786a2.706,2.706,0,0,0-3.7-3.888A18.392,18.392,0,0,0,8.992,2.579a.539.539,0,0,0,.551.925,17.181,17.181,0,0,1,3.935-1.719,12.824,12.824,0,0,0-2.743,2.978A18.817,18.817,0,0,0,8.9,8.243a17.352,17.352,0,0,1-2.68-2.167A17.645,17.645,0,0,1,7.7,4.765a.539.539,0,1,0-.665-.847,18.558,18.558,0,0,0-5.127,6.293,18.4,18.4,0,0,0,1.45,18.774,2.706,2.706,0,0,0,3.7,3.888,18.385,18.385,0,0,0,29.7-14.488,18.229,18.229,0,0,0-3.362-10.6ZM34.2,18.924h1.482A17.169,17.169,0,0,1,31.3,29.913c-.438-.432-.9-.841-1.372-1.225a2.7,2.7,0,0,0-1.042-3.228,28.288,28.288,0,0,0,.861-6.536h2.069a.539.539,0,0,0,0-1.077H29.743a27.457,27.457,0,0,0-1.475-8.572Q29.008,8.8,29.7,8.258a2.7,2.7,0,0,0,2.869.214,17.143,17.143,0,0,1,3.111,9.375H34.2a.539.539,0,0,0,0,1.077ZM7.066,28.514A2.7,2.7,0,0,0,4.2,28.3a17.143,17.143,0,0,1-3.111-9.376H4.907a2.715,2.715,0,0,0,2.234,2.137A26.717,26.717,0,0,0,8.505,27.5Q7.764,27.97,7.066,28.514ZM15.7,11.96a2.714,2.714,0,0,0,2.147,2.311v3.576H10.215a2.716,2.716,0,0,0-2-2.088A25.726,25.726,0,0,1,9.45,9.837,18.332,18.332,0,0,0,15.7,11.96ZM27.4,25.014a2.7,2.7,0,0,0-2.065.959,18.216,18.216,0,0,0-6.406-1.349v-5.7h9.742a27.259,27.259,0,0,1-.793,6.133,2.7,2.7,0,0,0-.477-.043Zm-8.471-7.167V14.27a2.714,2.714,0,0,0,2.147-2.311,18.264,18.264,0,0,0,6.255-2.121,26.477,26.477,0,0,1,1.34,8.008H18.924Zm2.067-6.964a2.716,2.716,0,0,0-2.067-1.92V1.1c2.5.219,4.842,1.954,6.655,4.944a18.667,18.667,0,0,1,1.368,2.77,17.19,17.19,0,0,1-5.956,2.068Zm-2.606-.9a1.631,1.631,0,1,1-1.631,1.631A1.632,1.632,0,0,1,18.385,9.986ZM7.561,16.755a1.631,1.631,0,1,1-1.63,1.631h0A1.632,1.632,0,0,1,7.561,16.755Zm.658,4.257a2.716,2.716,0,0,0,2-2.088h7.632v5.7a18.431,18.431,0,0,0-8.4,2.31A25.729,25.729,0,0,1,8.219,21.012Zm9.628,4.69v9.966c-2.285-.2-4.476-1.7-6.22-4.266a17.883,17.883,0,0,1-1.8-3.445A17.353,17.353,0,0,1,17.847,25.7Zm1.077,0a17.146,17.146,0,0,1,5.883,1.222,2.706,2.706,0,0,0,1.171,3.1c-1.836,3.383-4.364,5.4-7.054,5.641Zm6.841,2.02A1.631,1.631,0,1,1,27.4,29.352,1.632,1.632,0,0,1,25.765,27.722ZM32.94,6.078a1.631,1.631,0,1,1-1.631-1.631A1.632,1.632,0,0,1,32.94,6.078ZM28.98,4.7a2.7,2.7,0,0,0,0,2.758q-.537.416-1.1.788A19.59,19.59,0,0,0,26.5,5.487,13.443,13.443,0,0,0,23.322,1.8,17.318,17.318,0,0,1,28.98,4.7Zm-17.354.67C13.37,2.8,15.561,1.306,17.847,1.1v7.86a2.716,2.716,0,0,0-2.067,1.919,17.258,17.258,0,0,1-5.952-2.07A17.88,17.88,0,0,1,11.626,5.369ZM5.473,6.856A18.435,18.435,0,0,0,8.506,9.273,26.714,26.714,0,0,0,7.141,15.71a2.715,2.715,0,0,0-2.234,2.137H1.086A17.184,17.184,0,0,1,5.473,6.856ZM5.462,32.324a1.631,1.631,0,1,1,1.631-1.631A1.632,1.632,0,0,1,5.462,32.324Zm2.329-.252a2.7,2.7,0,0,0,0-2.757q.538-.416,1.1-.789a18.821,18.821,0,0,0,1.84,3.481,12.831,12.831,0,0,0,2.733,2.97,17.311,17.311,0,0,1-5.677-2.906ZM27,30.4a2.7,2.7,0,0,0,2.339-.8c.419.343.825.708,1.212,1.091a17.212,17.212,0,0,1-7.265,4.3A14.03,14.03,0,0,0,27,30.4Z" />
    </g>
</svg>

const SoftDevelopemnt = () => <svg xmlns="http://www.w3.org/2000/svg" width="39.186"
    height="39.34" viewBox="0 0 39.186 39.34">
    <path className="a"
        d="M40.186,23.589a1.152,1.152,0,0,0-.637-1.031L36.232,20.9l3.317-1.658a1.152,1.152,0,0,0,0-2.062l-8.676-4.338a1.149,1.149,0,0,0-.566-.852l-.945-.546a8.532,8.532,0,0,0,0-2.14l.945-.546a1.152,1.152,0,0,0,.422-1.574L28.424,3.19a1.152,1.152,0,0,0-1.574-.422l-.949.548a8.716,8.716,0,0,0-1.849-1.076V1.153A1.153,1.153,0,0,0,22.9,0h-4.61a1.153,1.153,0,0,0-1.153,1.153V2.241a8.716,8.716,0,0,0-1.849,1.076l-.949-.548a1.152,1.152,0,0,0-1.574.422L10.458,7.183a1.152,1.152,0,0,0,.422,1.574l.945.546a8.532,8.532,0,0,0,0,2.14l-.945.546a1.15,1.15,0,0,0-.566.852L1.637,17.179a1.152,1.152,0,0,0,0,2.062L4.954,20.9,1.637,22.558a1.152,1.152,0,0,0,0,2.062l3.317,1.658L1.637,27.936a1.152,1.152,0,0,0,0,2.062l18.441,9.22a1.152,1.152,0,0,0,1.031,0L39.549,30a1.152,1.152,0,0,0,0-2.062l-3.317-1.658,3.317-1.658A1.152,1.152,0,0,0,40.186,23.589ZM14.221,11.79a6.39,6.39,0,0,1,0-2.835,1.152,1.152,0,0,0-.549-1.247l-.642-.371,1.153-2,.647.373a1.153,1.153,0,0,0,1.355-.149,6.472,6.472,0,0,1,2.448-1.424,1.153,1.153,0,0,0,.807-1.1V2.305h2.305v.737a1.153,1.153,0,0,0,.807,1.1A6.473,6.473,0,0,1,25,5.566a1.153,1.153,0,0,0,1.355.149L27,5.341l1.153,2-.642.371a1.152,1.152,0,0,0-.549,1.247,6.39,6.39,0,0,1,0,2.835,1.152,1.152,0,0,0,.549,1.247l.642.371L27,15.4l-.647-.374A1.153,1.153,0,0,0,25,15.18,6.471,6.471,0,0,1,22.553,16.6a1.153,1.153,0,0,0-.807,1.1v.737H19.441V17.7a1.153,1.153,0,0,0-.807-1.1,6.472,6.472,0,0,1-2.448-1.424,1.152,1.152,0,0,0-1.355-.149l-.647.374-1.153-2,.642-.371A1.152,1.152,0,0,0,14.221,11.79ZM4.73,18.21l6.527-3.263,1.506,2.609a1.152,1.152,0,0,0,1.574.422l.949-.548a8.716,8.716,0,0,0,1.849,1.076v1.088a1.153,1.153,0,0,0,1.153,1.153H22.9a1.153,1.153,0,0,0,1.153-1.153V18.505A8.716,8.716,0,0,0,25.9,17.429l.949.548a1.152,1.152,0,0,0,1.574-.422l1.506-2.609,6.527,3.263L20.593,26.142ZM36.457,28.967,20.593,36.9,4.73,28.967l2.8-1.4L20.078,33.84a1.152,1.152,0,0,0,1.031,0l12.547-6.273ZM20.593,31.52,4.73,23.589l2.8-1.4,12.547,6.273a1.152,1.152,0,0,0,1.031,0l12.547-6.273,2.8,1.4Z"
        transform="translate(-1 0)" />
    <path className="a"
        d="M205.226,88.452A4.226,4.226,0,1,0,201,84.226,4.231,4.231,0,0,0,205.226,88.452Zm0-6.147a1.921,1.921,0,1,1-1.921,1.921A1.923,1.923,0,0,1,205.226,82.305Z"
        transform="translate(-185.633 -73.853)" />
</svg>

const Ecommerce = () => <svg xmlns="http://www.w3.org/2000/svg" width="40.261"
    height="40.261" viewBox="0 0 40.261 40.261">
    <path className="a"
        d="M2.587,7.6A1.975,1.975,0,0,1,4.014,7H9.631a3.341,3.341,0,0,1,3.338,3.028l.686,7.037h4.733a7.439,7.439,0,0,1-.23-2.9h0a7.381,7.381,0,1,1,14.426,2.9H41.59a.671.671,0,0,1,.659.8L39.1,34.22a2.013,2.013,0,0,1-1.976,1.634H11.395a.671.671,0,1,0,0,1.342H37.564a.671.671,0,0,1,0,1.342H32.85a3.32,3.32,0,0,1,.688,2.013,3.355,3.355,0,1,1-6.71,0,3.32,3.32,0,0,1,.688-2.013H18.758a3.32,3.32,0,0,1,.688,2.013,3.355,3.355,0,0,1-6.71,0,3.32,3.32,0,0,1,.688-2.013h-2.03a2.013,2.013,0,0,1-.076-4.019L8.778,11.026H4.089a2.064,2.064,0,0,1-2.08-1.837A1.979,1.979,0,0,1,2.587,7.6ZM28.17,40.55a2.013,2.013,0,1,0,2.013-2.013A2.013,2.013,0,0,0,28.17,40.55Zm-14.091,0a2.013,2.013,0,1,0,2.013-2.013A2.013,2.013,0,0,0,14.079,40.55Zm10.736-8.723V29.719a2.678,2.678,0,0,1-1.136-.617.658.658,0,0,1-.206.042H20.2l.262,2.684Zm5.471,0,.448-2.684H27.5a.658.658,0,0,1-.206-.042,2.678,2.678,0,0,1-1.136.617v2.108Zm7.157-10.736H33.435l-.448,2.684H37Zm-7.26,0h-.466a7.368,7.368,0,0,1-1.146.666.671.671,0,0,0-.4.609v.068h.672a.671.671,0,0,1,.671.671v.671h2.116l.448-2.684ZM22.8,23.775v1.342H28.17V23.775ZM14.7,27.8h4.019l-.262-2.684H14.44Zm5.368,0H22.9a2.643,2.643,0,0,1-.1-.671v-.671h-.671a.671.671,0,0,1-.671-.671v-.671H19.808Zm5.414.671a1.342,1.342,0,0,0,1.342-1.342v-.671H24.144v.671A1.342,1.342,0,0,0,25.486,28.472Zm2.589-.671h2.882l.448-2.684H29.512v.671a.671.671,0,0,1-.671.671H28.17v.671a2.643,2.643,0,0,1-.1.671Zm8.7-2.684H32.764L32.317,27.8h4.008Zm-4.678,4.026-.448,2.684h4.008l.447-2.684Zm-13.239,0h-4.02l.263,2.684h4.019Zm-4.545-5.368h4.019l-.262-2.684h-4.02Zm5.368,0H21.46V23.1a.671.671,0,0,1,.671-.671H22.8v-.067a.671.671,0,0,0-.4-.608,7.417,7.417,0,0,1-1.152-.667H19.415Zm9.834-13.224a5.986,5.986,0,0,0-4.717-1.5,6.056,6.056,0,0,0-5.305,5.271h0a6.087,6.087,0,0,0,.466,3.139c0,.01.009.02.013.031a6.031,6.031,0,0,0,3,3.047,2.024,2.024,0,0,1,1.178,1.826v.067h.671V15.052a.671.671,0,1,0-1.007.582.671.671,0,0,1-.671,1.162,2.01,2.01,0,1,1,2.349-3.233A2.01,2.01,0,1,1,27.834,16.8a.671.671,0,0,1-.671-1.162.671.671,0,1,0-1.007-.583v7.381h.671v-.067a2.025,2.025,0,0,1,1.181-1.827,6.058,6.058,0,0,0,3-3.062h0a6,6,0,0,0-1.5-6.925ZM4.089,9.684H8.778a1.348,1.348,0,0,1,1.338,1.2L12.67,34.511H37.127a.671.671,0,0,0,.659-.545l2.993-15.559H32.05a7.414,7.414,0,0,1-.882,1.342h7.067a.671.671,0,0,1,.662.782L36.884,32.609a.671.671,0,0,1-.662.56H14.488a.671.671,0,0,1-.668-.6L12.639,20.487a.671.671,0,0,1,.671-.738H19.8a7.356,7.356,0,0,1-.88-1.342H13.045a.671.671,0,0,1-.668-.6l-.745-7.643a2,2,0,0,0-2-1.818H4.014a.656.656,0,0,0-.478.205.649.649,0,0,0-.19.528A.727.727,0,0,0,4.089,9.684Z"
        transform="translate(-2 -3.645)" />
    <path className="a"
        d="M26.671,4.684A.671.671,0,0,1,26,4.013V2.671a.671.671,0,0,1,1.342,0V4.013A.671.671,0,0,1,26.671,4.684Z"
        transform="translate(-3.185 -2)" />
    <path className="a"
        d="M15.831,8.781a.671.671,0,1,1-.949-.949l.949-.949a.671.671,0,0,1,.949.949Z"
        transform="translate(14.771 -3.542)" />
    <path className="a"
        d="M12.013,19.342H10.671a.671.671,0,1,1,0-1.342h1.342a.671.671,0,1,1,0,1.342Z"
        transform="translate(22.209 -7.264)" />
    <path className="a"
        d="M42.684,18.671a.671.671,0,0,1-.671.671H40.671a.671.671,0,0,1,0-1.342h1.342A.671.671,0,0,1,42.684,18.671Z"
        transform="translate(-27.921 -7.264)" />
    <path className="a"
        d="M38.521,8.976a.671.671,0,0,1-.474-.2l-.95-.949a.671.671,0,1,1,.949-.949l.949.95a.671.671,0,0,1-.475,1.145Z"
        transform="translate(-22.349 -3.541)" />
</svg>

const HealthCare = () => <svg xmlns="http://www.w3.org/2000/svg" width="39.3" height="39.485"
    viewBox="0 0 39.3 39.485">
    <g transform="translate(-2.24 -2.199)">
        <path className="a"
            d="M33.584,11.641H31.6V9.66a.66.66,0,0,0-.66-.66H28.3a.66.66,0,0,0-.66.66v1.981H25.66a.66.66,0,0,0-.66.66v2.641a.66.66,0,0,0,.66.66h1.981v1.981a.66.66,0,0,0,.66.66h2.641a.66.66,0,0,0,.66-.66V15.6h1.981a.66.66,0,0,0,.66-.66V12.3A.66.66,0,0,0,33.584,11.641Zm-.66,2.641H30.942a.66.66,0,0,0-.66.66v1.981H28.962V14.942a.66.66,0,0,0-.66-.66H26.321V12.962H28.3a.66.66,0,0,0,.66-.66V10.321h1.321V12.3a.66.66,0,0,0,.66.66h1.981Z"
            transform="translate(-7.732 -2.311)" />
        <path className="a"
            d="M50.649,16.827a3.023,3.023,0,0,0,.02-.35,2.654,2.654,0,0,0-2.1-2.582,2.688,2.688,0,0,0-3.1,1.961l-2.905,8.359a1.077,1.077,0,0,0-.125.059L36.6,27.7a5.954,5.954,0,0,0-2.938,5.124v6.22a.66.66,0,0,0-.66.66v5.282a.66.66,0,0,0,.66.66H42.9a.66.66,0,0,0,.66-.66V39.7a.66.66,0,0,0-.66-.66V37.586a2.007,2.007,0,0,1,.66-1.479l4.463-3.968a3.256,3.256,0,0,0,1-1.618L51.9,19.8a2.611,2.611,0,0,0,.092-.687,2.654,2.654,0,0,0-1.34-2.291Zm-3.922-.581A1.4,1.4,0,0,1,48.3,15.19a1.321,1.321,0,0,1,1.05,1.288v.013a2.707,2.707,0,0,0-2.568,2.02L44.938,24.2a2.773,2.773,0,0,0-.885-.251ZM42.244,44.321H34.321V40.359h7.923Zm8.379-24.859L47.751,30.184a1.968,1.968,0,0,1-.594.964l-4.47,3.968a3.338,3.338,0,0,0-1.1,2.469v1.453h-6.6v-6.22a4.656,4.656,0,0,1,2.285-3.988l5.83-3.414A1.321,1.321,0,0,1,44.9,25.9a1.36,1.36,0,0,1,.132,1,1.321,1.321,0,0,1-.621.8l-3.783,2.186a.66.66,0,0,0,.66,1.142l3.783-2.186a2.607,2.607,0,0,0,1.235-1.6,2.646,2.646,0,0,0-.264-2l-.04-.059,2.04-6.292a1.4,1.4,0,0,1,1.571-1.056,1.321,1.321,0,0,1,1.05,1.288A1.137,1.137,0,0,1,50.623,19.462Z"
            transform="translate(-10.45 -3.957)" />
        <path className="a"
            d="M20.569,39.04V32.82A5.954,5.954,0,0,0,17.631,27.7l-5.837-3.427c-.04-.02-.086-.033-.125-.053L8.783,15.9A2.712,2.712,0,0,0,5.66,13.9a2.654,2.654,0,0,0-2.1,2.582,3.023,3.023,0,0,0,.02.35,2.654,2.654,0,0,0-1.34,2.291,2.919,2.919,0,0,0,.086.687L5.2,30.516a3.246,3.246,0,0,0,1,1.624l4.457,3.968a1.989,1.989,0,0,1,.667,1.479V39.04a.66.66,0,0,0-.66.66v5.282a.66.66,0,0,0,.66.66h9.244a.66.66,0,0,0,.66-.66V39.7A.66.66,0,0,0,20.569,39.04ZM4.881,16.478a1.321,1.321,0,0,1,1.043-1.288,1.427,1.427,0,0,1,1.6,1.1l2.654,7.653a2.773,2.773,0,0,0-.885.251L7.463,18.545a2.739,2.739,0,0,0-2.582-2.053Zm6.656,18.64L7.073,31.15a1.958,1.958,0,0,1-.594-.971L3.6,19.463a1.4,1.4,0,0,1-.04-.343A1.321,1.321,0,0,1,4.6,17.832,1.416,1.416,0,0,1,6.2,18.921l2.027,6.259-.04.059a2.646,2.646,0,0,0-.264,2,2.607,2.607,0,0,0,1.235,1.6l3.783,2.186a.66.66,0,0,0,.66-1.142L9.813,27.7a1.321,1.321,0,0,1-.621-.8,1.36,1.36,0,0,1,.132-1,1.321,1.321,0,0,1,1.8-.489l5.837,3.42a4.656,4.656,0,0,1,2.285,3.988v6.22h-6.6V37.587A3.321,3.321,0,0,0,11.537,35.118Zm8.372,9.2H11.986V40.36h7.923Z"
            transform="translate(0 -3.959)" />
        <path className="a"
            d="M35.542,4.135a6.6,6.6,0,0,0-9.341,0h0a6.6,6.6,0,1,0-9.34,9.332l8.874,8.874a.66.66,0,0,0,.934,0l8.874-8.874a6.607,6.607,0,0,0,0-9.333ZM26.2,20.942l-8.407-8.407A5.282,5.282,0,0,1,21.533,3.52a5.227,5.227,0,0,1,3.733,1.55l.469.469a.66.66,0,0,0,.934,0l.47-.47a5.28,5.28,0,0,1,7.47,7.465Z"
            transform="translate(-4.312 0)" />
    </g>
</svg>

const ErpSysteam = () => <svg xmlns="http://www.w3.org/2000/svg" width="42.206"
    height="42.152" viewBox="0 0 42.206 42.152">
    <g transform="translate(-0.865 -1)">
        <path className="a"
            d="M13.119,39a6.119,6.119,0,1,0,6.119,6.119A6.126,6.126,0,0,0,13.119,39Zm0,10.878a4.759,4.759,0,1,1,4.759-4.759A4.764,4.764,0,0,1,13.119,49.878Z"
            transform="translate(-1.964 -12.165)" />
        <path className="a"
            d="M14.4,43a3.4,3.4,0,1,0,3.4,3.4A3.4,3.4,0,0,0,14.4,43Zm0,5.439a2.04,2.04,0,1,1,2.04-2.04A2.042,2.042,0,0,1,14.4,48.439Z"
            transform="translate(-3.244 -13.445)" />
        <path className="a"
            d="M43.071,37.713l-8.8-5.28v2.56h-6.8A17.676,17.676,0,1,0,3.009,18H.865l4.851,5.821L10.567,18H8.454a12.238,12.238,0,1,1,12.9,12.883v-.5l-1.9-.467q-.125-.34-.284-.676l.632-1.043h4.95a3.4,3.4,0,0,0,3.4-3.4V12.558a3.4,3.4,0,0,0-3.4-3.4H16.594a3.4,3.4,0,0,0-3.4,3.4V21.4h1.36V12.558a2.042,2.042,0,0,1,2.04-2.04h8.158a2.042,2.042,0,0,1,2.04,2.04V24.8a2.037,2.037,0,0,1-1.36,1.915V11.878H15.914V24.307l-1.044.632q-.337-.157-.676-.283l-.466-1.9H8.583l-.467,1.9q-.339.125-.676.284L5.763,23.924,2.124,27.563l1.015,1.677q-.157.338-.284.676l-1.9.466v5.145l1.9.467q.125.34.283.676L2.125,38.346l3.638,3.638,1.677-1.015c.225.105.451.2.676.284l.467,1.9h5.145l.467-1.9q.339-.125.676-.284l1.677,1.015,3.639-3.639-1.015-1.677c.049-.1.088-.211.133-.316H35.63V34.834l4.8,2.879-4.8,2.879V39.073H26.112v1.36h8.158v2.56Zm-8.8-19.036a13.6,13.6,0,0,0-27.195,0v.68h.588L5.716,21.694,3.768,19.357h.588v-.68a16.317,16.317,0,1,1,17,16.3V32.24A13.6,13.6,0,0,0,34.271,18.677Zm-17,5.439h6.8v2.719H19.459L17.274,24.65Zm6.8-1.36h-6.8V18.677h6.8Zm0-9.518v4.079h-6.8V13.238ZM16.339,40.269l-1.409-.853-.339.175a7.484,7.484,0,0,1-1.174.491l-.364.116-.392,1.595H9.648L9.256,40.2l-.364-.116a7.518,7.518,0,0,1-1.175-.491l-.339-.175-1.408.853L3.839,38.138l.853-1.409-.175-.339a7.441,7.441,0,0,1-.491-1.174l-.116-.364-1.594-.392V31.447l1.594-.392.116-.364a7.55,7.55,0,0,1,.491-1.174l.175-.339-.853-1.409L5.97,25.639l1.409.853.339-.175a7.484,7.484,0,0,1,1.174-.491l.364-.116.392-1.594h3.014l.392,1.594.364.116a7.441,7.441,0,0,1,1.174.491l.339.175,1.409-.853,2.131,2.131-.853,1.409.176.339a7.517,7.517,0,0,1,.491,1.174l.116.364,1.594.392v3.014l-1.594.392-.116.364a7.479,7.479,0,0,1-.491,1.174l-.176.339.853,1.409Z" />
        <path className="a" d="M34,57h1.36v1.36H34Z" transform="translate(-10.607 -17.927)" />
        <path className="a" d="M30,57h1.36v1.36H30Z" transform="translate(-9.327 -17.927)" />
        <path className="a" d="M27,21h1.36v1.36H27Z" transform="translate(-8.366 -6.403)" />
        <path className="a" d="M31,21h1.36v1.36H31Z" transform="translate(-9.647 -6.403)" />
        <path className="a" d="M31,29h1.36v1.36H31Z" transform="translate(-9.647 -8.964)" />
        <path className="a" d="M27,29h1.36v1.36H27Z" transform="translate(-8.366 -8.964)" />
    </g>
</svg>

const CrmSysteam = () => <svg xmlns="http://www.w3.org/2000/svg" width="42.206"
    height="42.152" viewBox="0 0 42.206 42.152">
    <g transform="translate(-1 -1)">
        <path className="a"
            d="M29.508,45a6.508,6.508,0,1,0,6.508,6.508A6.515,6.515,0,0,0,29.508,45ZM26.743,55.743a2.883,2.883,0,0,1,5.529,0,5.036,5.036,0,0,1-5.529,0Zm1.318-4.958a1.446,1.446,0,1,1,1.446,1.446A1.448,1.448,0,0,1,28.062,50.785Zm5.353,3.937a4.362,4.362,0,0,0-1.824-1.941,2.892,2.892,0,1,0-4.167,0A4.362,4.362,0,0,0,25.6,54.723a5.062,5.062,0,1,1,7.814,0Z"
            transform="translate(-6.092 -12.184)" />
        <path className="a"
            d="M23.416,1a6.5,6.5,0,0,0-6.049,8.893,3.565,3.565,0,0,0-1.182-.215,2.172,2.172,0,0,0-2.169,2.169v1.788a3.8,3.8,0,0,1-1.836,3.242,5.229,5.229,0,0,0-2.269,2.829l-.017.051L1,19.015V31.37H23.416a2.162,2.162,0,0,0,2.01-2.976,2.151,2.151,0,0,0,1.041-3.532,2.136,2.136,0,0,0,0-2.892,2.16,2.16,0,0,0-1.6-3.616H21.247A1.448,1.448,0,0,1,19.8,16.908V13.293a3.555,3.555,0,0,0-.041-.4A6.507,6.507,0,1,0,23.416,1ZM9.677,29.924H2.446V20.587l7.231.6ZM21.247,19.8h3.616a.723.723,0,0,1,0,1.446H19.8v1.446h5.062a.723.723,0,1,1,0,1.446H19.8v1.446h5.062a.723.723,0,1,1,0,1.446H19.8v1.446h3.616a.723.723,0,0,1,0,1.446H11.123V20.641l.16-.477a3.778,3.778,0,0,1,1.641-2.046,5.255,5.255,0,0,0,2.538-4.483V11.847a.724.724,0,0,1,.723-.723,2.172,2.172,0,0,1,2.169,2.169v3.616A2.894,2.894,0,0,0,21.247,19.8Zm2.169-7.231a5.062,5.062,0,1,1,5.062-5.062A5.068,5.068,0,0,1,23.416,12.57Z" />
        <path className="a"
            d="M51.508,23a6.508,6.508,0,1,0,6.508,6.508A6.515,6.515,0,0,0,51.508,23Zm0,11.57a5.062,5.062,0,1,1,5.062-5.062A5.068,5.068,0,0,1,51.508,34.57Z"
            transform="translate(-12.184 -6.092)" />
        <path className="a"
            d="M54.785,28.446v2.892H53.339V27H51.892v4.339H50.446V29.892H49v2.892h7.231V28.446Z"
            transform="translate(-13.291 -7.199)" />
        <path className="a" d="M31,9h1.446v1.446H31Z" transform="translate(-8.307 -2.215)" />
        <path className="a" d="M35,9h1.446v1.446H35Z" transform="translate(-9.415 -2.215)" />
        <path className="a" d="M27,9h1.446v1.446H27Z" transform="translate(-7.199 -2.215)" />
        <path className="a"
            d="M50.224,15.484l.966,1.539,1.079-5.4-1.418-.284-.388,1.94a18.716,18.716,0,0,0-7.274-5.754l-.612,1.31A17.19,17.19,0,0,1,50.224,15.484Z"
            transform="translate(-11.512 -1.808)" />
        <path className="a"
            d="M7.528,17.1l1.311.612a17.191,17.191,0,0,1,6.645-7.648L17.023,9.1l-5.4-1.08-.283,1.417,1.94.388A18.709,18.709,0,0,0,7.528,17.1Z"
            transform="translate(-1.808 -1.944)" />
        <path className="a"
            d="M10.065,44.879,9.1,43.34l-1.079,5.4,1.418.284.388-1.94A18.716,18.716,0,0,0,17.1,52.836l.613-1.31A17.188,17.188,0,0,1,10.065,44.879Z"
            transform="translate(-1.944 -11.724)" />
        <path className="a"
            d="M52.836,43.188l-1.311-.612a17.191,17.191,0,0,1-6.645,7.648l-1.539.965,5.4,1.08.284-1.418-1.94-.388a18.706,18.706,0,0,0,5.754-7.274Z"
            transform="translate(-11.724 -11.512)" />
    </g>
</svg>

const LogisticsSolution = () => <svg xmlns="http://www.w3.org/2000/svg" width="42.206"
    height="42.152" viewBox="0 0 42.206 42.152">
    <g transform="translate(0 0)">
        <g transform="translate(17.269 17.266)">
            <path className="a"
                d="M17.531,34.177c-.047,0-.1,0-.143-.005a1.832,1.832,0,0,1-1.337-.746l-2.086-2.861a.746.746,0,0,0-.157-.155l-3.06-2.254a1.835,1.835,0,0,1-.209-2.777,1.9,1.9,0,0,1,2.121-.4l2.245.981,4.663-5.025.4-1.026-.4.763-8.158-4.317a1.923,1.923,0,0,1-.952-1.43A1.9,1.9,0,0,1,11,13.341a1.711,1.711,0,0,1,1.571-.461l11.864,2.513a.184.184,0,0,0,.181-.054l4.255-4.521A3.051,3.051,0,0,1,31.058,10a3.034,3.034,0,0,1,2.326.791,3.264,3.264,0,0,1,.793,2.326,3.056,3.056,0,0,1-.815,2.185L28.83,19.578a.185.185,0,0,0-.057.18L31.5,31.763a1.7,1.7,0,0,1-.454,1.6,1.869,1.869,0,0,1-1.578.547,1.9,1.9,0,0,1-1.406-.9l-4.542-8.4-.85-.63.589.632-5.015,4.661.981,2.248a1.9,1.9,0,0,1-.4,2.119,1.841,1.841,0,0,1-1.3.535Zm5.852-11.34a1.91,1.91,0,0,1,1.632.91l4.542,8.4.879.6-.611-.61-2.732-11.99a1.908,1.908,0,0,1,.558-1.834l4.528-4.267a1.491,1.491,0,0,0,.271-.953,1.68,1.68,0,0,0-.287-1.079,1.607,1.607,0,0,0-1.079-.287,1.472,1.472,0,0,0-.95.271L25.88,16.516a1.921,1.921,0,0,1-1.806.56L12.21,14.563l-.4,1.024.4-.763,8.158,4.317a1.933,1.933,0,0,1,.948,1.394,1.911,1.911,0,0,1-.49,1.57l-5.08,5.474a.859.859,0,0,1-.977.2l-2.808-1.226a.189.189,0,0,0-.205.038l3.076,2.419a2.472,2.472,0,0,1,.523.525L17.45,32.4c.212-.041.228-.126.2-.2L16.421,29.4a.863.863,0,0,1,.2-.977l5.462-5.077a1.919,1.919,0,0,1,1.3-.508Zm9.387-8.161h.017Z"
                transform="translate(-10 -9.999)" />
        </g>
        <g transform="translate(16.416 8.202)">
            <path className="a"
                d="M10.369,14.68a.863.863,0,0,1-.387-1.635l16.395-8.2a.865.865,0,0,1,1.25.772v7.339a.863.863,0,1,1-1.727,0V7.011L10.754,14.588a.853.853,0,0,1-.385.092Z"
                transform="translate(-9.506 -4.75)" />
        </g>
        <g transform="translate(0 8.203)">
            <path className="a"
                d="M14.843,30.221a.855.855,0,0,1-.42-.109L.444,22.341A.864.864,0,0,1,0,21.587V5.613a.863.863,0,0,1,1.249-.772l16.395,8.2a.864.864,0,0,1-.772,1.546L1.727,7.01V21.079L15.262,28.6a.863.863,0,0,1-.42,1.618Z"
                transform="translate(0 -4.75)" />
        </g>
        <g transform="translate(0 0)">
            <path className="a"
                d="M33.674,9.929a.87.87,0,0,1-.387-.092L17.258,1.828,1.25,9.838A.863.863,0,0,1,.476,8.294L16.871.091a.867.867,0,0,1,.772,0l16.416,8.2a.863.863,0,0,1-.385,1.635Z"
                transform="translate(0 0)" />
        </g>
        <g transform="translate(7.845 3.923)">
            <path className="a"
                d="M5.406,18.62a.864.864,0,0,1-.863-.863V11.337a.865.865,0,0,1,.477-.772l16.395-8.2a.864.864,0,1,1,.772,1.546L6.27,11.872v5.887a.862.862,0,0,1-.863.862Z"
                transform="translate(-4.543 -2.272)" />
        </g>
    </g>
</svg>

const MobileApp = () => <svg xmlns="http://www.w3.org/2000/svg" width="42.206"
    height="42.152" viewBox="0 0 42.206 42.152">
    <g transform="translate(-21 -10)">
        <path className="a"
            d="M212.065,431.413a1.37,1.37,0,1,0,1.37,1.37A1.37,1.37,0,0,0,212.065,431.413Zm0,1.746a.376.376,0,1,1,.376-.376A.376.376,0,0,1,212.065,433.159Z"
            transform="translate(-173.99 -386.524)" />
        <path className="a" d="M120.662,47H120.5a.5.5,0,1,0,0,.993h.166a.5.5,0,1,0,0-.993Z"
            transform="translate(-90.804 -33.937)" />
        <path className="a" d="M150.113,47H142.5a.5.5,0,1,0,0,.993h7.617a.5.5,0,1,0,0-.993Z"
            transform="translate(-110.983 -33.937)" />
        <path className="a"
            d="M52.072,159.993H55.86a.5.5,0,1,0,0-.993H52.072a.5.5,0,1,0,0,.993Z"
            transform="translate(-28.044 -136.664)" />
        <path className="a"
            d="M122.3,159.5a.5.5,0,0,0,.5.5h4.736a.5.5,0,0,0,0-.993H122.8A.5.5,0,0,0,122.3,159.5Z"
            transform="translate(-92.913 -136.664)" />
        <path className="a"
            d="M60.146,185.5a.5.5,0,0,0-.5-.5H52.072a.5.5,0,0,0,0,.993h7.577A.5.5,0,0,0,60.146,185.5Z"
            transform="translate(-28.044 -160.512)" />
        <path className="a" d="M169.5,185h-.947a.5.5,0,0,0,0,.993h.947a.5.5,0,1,0,0-.993Z"
            transform="translate(-134.884 -160.512)" />
        <path className="a" d="M56.205,211H52.072a.5.5,0,0,0,0,.993h4.133a.5.5,0,0,0,0-.993Z"
            transform="translate(-28.044 -184.359)" />
        <path className="a" d="M131.346,211h-4.391a.5.5,0,1,0,0,.993h4.391a.5.5,0,1,0,0-.993Z"
            transform="translate(-96.727 -184.359)" />
        <path className="a"
            d="M57.548,30.641a2.3,2.3,0,0,0-1.515-1.527,2.214,2.214,0,0,0-.948-.091,2.308,2.308,0,0,0-1.616.95,2.3,2.3,0,0,0-4.088.414,2.332,2.332,0,0,0-.315-.182V13.99A4.008,4.008,0,0,0,45.06,10H31.089a3.971,3.971,0,0,0-3.962,3.99v4.786H23.21A2.21,2.21,0,0,0,21,20.985V28.65a2.209,2.209,0,0,0,2.207,2.213h3.919v15.88a3.971,3.971,0,0,0,3.962,3.99H45.06a4.008,4.008,0,0,0,4.005-3.99v-.474a6.491,6.491,0,0,0,3.93.036L55.3,45.6a6.535,6.535,0,0,0,4.33-8.153ZM28.12,13.99a2.976,2.976,0,0,1,2.969-3H45.06a3.013,3.013,0,0,1,3.012,3V15.3H28.12ZM48.072,46.743a3.013,3.013,0,0,1-3.012,3H31.089a2.976,2.976,0,0,1-2.969-3V43.116H44.435l1.483.938a6.549,6.549,0,0,0,2.154,1.8Zm-7.051-6.962A2.316,2.316,0,0,1,43.9,39.3l.148.084.793,2.589c.029.1.061.189.094.281Zm13.991,4.868-2.307.707a5.54,5.54,0,0,1-6.912-3.671l-1.959-6.4a.5.5,0,0,0-.617-.331h0a.5.5,0,0,0-.333.622l.782,2.554a3.31,3.31,0,0,0-3.783,1.544.5.5,0,0,0,.166.666l2.816,1.781H28.12V30.863h.672A4.46,4.46,0,0,0,31.9,35.328a.492.492,0,0,0,.129.017.5.5,0,0,0,.437-.259.511.511,0,0,0,.043-.368c-.159-.653-.414-2.495.263-3.359a1.392,1.392,0,0,1,1.177-.5h1.485a2.2,2.2,0,0,0,2.2-2.2V20.982a2.206,2.206,0,0,0-2.206-2.206H32.756a.5.5,0,1,0,0,.993h2.68a1.211,1.211,0,0,1,1.211,1.211v7.666a1.223,1.223,0,0,1-1.223,1.223H33.951a2.353,2.353,0,0,0-1.961.878,4.688,4.688,0,0,0-.6,3.255,3.51,3.51,0,0,1-1.6-3.315.775.775,0,0,0-.761-.818H23.208a1.216,1.216,0,0,1-1.214-1.223V20.986a1.216,1.216,0,0,1,1.216-1.216h6.069a.5.5,0,0,0,0-.993H28.12V16.292H48.072V29.977a2.3,2.3,0,0,0-1.812.879L44.13,23.9a2.306,2.306,0,1,0-4.41,1.351l2.144,7a.5.5,0,0,0,.617.331h0a.5.5,0,0,0,.333-.622l-2.144-7a1.321,1.321,0,0,1,.338-1.328,1.012,1.012,0,0,1,.14-.118,1.317,1.317,0,0,1,2.032.677l3.921,12.8a.5.5,0,0,0,.95-.291l-1.236-4.036a1.313,1.313,0,1,1,2.51-.769l1.236,4.036a.5.5,0,0,0,.95-.291l-1.236-4.037a1.313,1.313,0,1,1,2.51-.769l1.236,4.037a.5.5,0,1,0,.95-.291L54.088,31.7a1.321,1.321,0,0,1,.343-1.333.992.992,0,0,1,.141-.118,1.321,1.321,0,0,1,1.387-.093,1.3,1.3,0,0,1,.639.775l2.084,6.8a5.541,5.541,0,0,1-3.67,6.912Z"
            transform="translate(0 0)" />
    </g>
</svg>

export default {
    cancle,
    eventbanner,
    contactbanner,
    loactions,
    championbanner,
    reformerimg,
    culturebanner,
    longarrow,
    axita,
    jemin,
    dipak,
    ronak,
    vaman,
    jemis,
    yash,
    ankit,
    raj,
    nikul,
    dhruvil,
    amit,
    hemant,
    hr,
    viral,
    dhruvi,
    dhruti,
    hiral,
    prathna,
    shruti,
    jaya,
    startup,
    rating,
    vaidehi,
    careerbanner,
    blogbanner,
    lowprices,
    goal,
    implementation,
    send,
    careersettings,
    workbanner,
    tech,
    tyreexpert,
    headphones,
    usergroup,
    paintbrush,
    s1,
    settings,
    rocket,
    timemanagement,
    getstarted,
    s4,
    poc,
    piechart,
    search,
    employee,
    productlife,
    sellproduct,
    Outline,
    ceo,
    Ecommercesolution,
    smartphone,
    servicebanner,
    cto,
    satisfaction,
    iconquote,
    technology,
    response,
    team,
    badge,
    virus,
    playbtn,
    object,
    trust1,
    banner2,
    trust2,
    trust3,
    trust4,
    trust5,
    rightarrow,
    customer,
    mainLogo,
    homeBanner,
    call,
    location,
    email,
    paper,
    ftrlogo,
    facebook,
    insta,
    twitter,
    linked,
    product,
    expyrs,
    ux,
    strongvalue,
    quality,
    support,
    node,
    metore,
    apple,
    android,
    react,
    native,
    angular,
    aws,
    mongo,
    graph,
    graphql,
    laravel,
    mysql,
    profile,
    quote,
    dotted,
    WebDevelopment,
    SoftDevelopemnt,
    Ecommerce,
    HealthCare,
    ErpSysteam,
    CrmSysteam,
    LogisticsSolution,
    MobileApp,
    perksOne,
    perksTwo,
    perksThree,
    perksFour,
}